import React, { useContext } from 'react';
import { EventDetailsContext } from '../../context/event_details.context';
import format from 'date-fns/format';
import { DATE_FORMAT } from '../../constants/event_details.constants';

const EndDate: React.FC = () => {
  const { event } = useContext(EventDetailsContext);
  if (!event?.ends_at) return null;
  return (
    <span data-testid='formatted-end-date'>
      {format(new Date(event?.ends_at), DATE_FORMAT)}
    </span>
  );
};

export default EndDate;
